module.exports = __webpack_public_path__ + "img/framework.76b3ceee.png";